<template>
    <!-- 申报新物资 -->
    <div class="declare-detail">
        <Row type="flex" justify="space-between" align="middle">
            <div class="title-l">
                <router-link to="/index/declare" class="span-box">
                    <Icon type="ios-arrow-back" />
                    <span>申报新物资</span>
                </router-link>
            </div>
        </Row>
        <Form ref="form" :model="form" :rules="rules" :label-width="100" class="">
            <Form-item label="选择厂" class="checkbox-block" prop="clique">
                <Checkbox-group v-model="form.clique">
                    <Checkbox
                    v-for="(item, index) in supplierClique"
                    :label="item.cliqueNo"
                    :key="index">{{item.cliqueName}}</Checkbox>
                </Checkbox-group>
            </Form-item>
            <FormItem label="物资分类" prop="productClassify">
                <Cascader
                        :data="productClassifyData"
                        v-model="form.productClassify"
                        @on-change="productClassifyChange"></Cascader>
            </FormItem>
            <FormItem label="物资名称" prop="productName">
                <Input v-model="form.productName"></Input>
            </FormItem>
            <FormItem label="物资规格" prop="productSpectype">
                <Input v-model="form.productSpectype"></Input>
                <p class="tip">例：0.5kg/斤，1kg/袋，2L/瓶， 200g*12/件</p>
            </FormItem>
            <FormItem label="物资单位" prop="productUnit">
                <Select v-model="form.productUnit"
                    @on-change="changeUnit"
                    placeholder="请选择" filterable style="width: 460px">
                    <Option v-for="(item, index) in specList2" :value="item" :key="index">{{item}}</Option>
                </Select>
            </FormItem>
            <FormItem label="标准单位" prop="normalProductUnit">
                <Radio-group v-model="form.normalProductUnit" size="large">
                    <Radio label="kg"></Radio>
                    <Radio label="L"></Radio>
                </Radio-group>
            </FormItem>
            <FormItem label="转化率" prop="rate">
                <Input v-model="form.rate"></Input>
                <p class="tip">转换率指1计量单位物资对标准单位的转换系数。</p>
                <p class="tip">例：某规格200g*8的物资，计量单位是件，标准单位是KG，转换率1.6。</p>
                <p class="tip">计量单位为斤的物资转换率是0.5。</p>
            </FormItem>
            <FormItem class="pass-submit">
                <Button type="primary" @click="handleSubmit('form')">确认提交</Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
import { queryProductClassify, getAllSpec, createRequest, getSupplierClique } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
import { creatMultidimensionalArray } from '@/assets/js/creatArr.js';

export default {
    data() {
        return {
            form: {
                productClassify: [],
                classifyNo: '',
                productName: '',
                productUnit: '',
                productSpectype: '',
                normalProductUnit: 'kg',
                rate: '',
                clique: []
            },
            rules: {
                productClassify: [
                    {
                        required: true,
                        message: '请选择物资分类',
                        type: 'array',
                        trigger: 'change'
                    }
                ],
                productName: [
                    {
                        required: true,
                        message: '请填写物资名称',
                        trigger: 'blur'
                    }
                ],
                productSpectype: [
                    {
                        required: true,
                        message: '请填写物资规格',
                        trigger: 'blur'
                    }
                ],
                productUnit: [
                    {
                        required: true,
                        message: '请填写物资单位',
                        trigger: 'change'
                    }
                ],
                rate: [
                    {
                        required: true,
                        message: '请填写转化率',
                        trigger: 'blur'
                    }
                ],
                clique: [
                    { required: true, type: 'array', min: 1, message: '请选择厂', trigger: 'change' }
                ]
            },
            specList2: [],
            productClassifyData: [],
            supplierClique: []
        };
    },
    mounted() {
        this.getProductClassify();
        this.getSupplierClique();
        setTimeout(() => {
            this.getAllSpec('productUnit');
        });
    },
    methods: {
        changeUnit(val) {
            if (val === '斤' || val === 'kg') {
                this.form.productSpectype = '0.5kg/斤';
                this.form.rate = '0.5';
            } else {
                this.form.rate = '';
            }
        },
        // 获取所有规格
        getAllSpec(spe) {
            this.$apollo.query({
                query: getAllSpec,
                variables: {
                    type: spe
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getAllSpec;
                if (data && data.data && data.code === 200) {
                    this.specList2 = data.data;
                }
            });
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const reg = /^\d+$|^\d*\.\d+$/g;
                    if (!reg.test(this.form.rate)) {
                        this.$setNotice('转化率输入有误');
                        return;
                    }
                    this.$apollo.mutate({
                        mutation: createRequest,
                        variables: {
                            supplierNo: Cookies.getJSON('USER-INFO').supplierNo,
                            cliqueNo: this.form.clique.join(','),
                            productName: this.form.productName,
                            classifyNo: this.form.classifyNo,
                            productSpectype: this.form.productSpectype,
                            productUnit: this.form.productUnit,
                            normalProductUnit: this.form.normalProductUnit,
                            rate: this.form.rate
                        }
                    }).then(res => {
                        const data = res.data.createRequest;
                        if (data && data.code === 200) {
                            this.$refs.form.resetFields();
                            this.$setNotice('提交成功');
                            this.$router.go(-1);
                        } else {
                            this.$setNotice(data.message);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        // 获取物资分类的联级列表
        getProductClassify() {
            this.$apollo.query({
                query: queryProductClassify,
                variables: {
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`,
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductClassify;
                if (data && data.data && data.code === 200) {
                    let parentData = [];
                    for (let i = 5;i > 0;i -= 1) {
                        if (data.data[i.toString()].length) {
                            parentData = creatMultidimensionalArray(
                                data.data[i.toString()],
                                parentData,
                                'classifyParentNo',
                                'classifyName',
                                'classifyNo'
                            );
                        } else {
                            continue;
                        }
                    }
                    parentData.forEach(ele => {
                        let classifyName, classifyNo, children, value, label;
                        ({ classifyName: label, classifyNo: value, children } = ele);
                        this.productClassifyData.push({
                            value,
                            label,
                            children
                        });
                    });
                } else {
                    this.$setNotice('分类列表获取失败，刷新试试吧');
                }
            });
        },
        // 选中物资分类
        productClassifyChange(val) {
            this.form.classifyNo = val[val.length - 1] || '';
        },
        getSupplierClique() {
            this.$apollo.query({
                query: getSupplierClique,
                variables: {
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getSupplierClique;
                if (data && data.data && data.code === 200) {
                    this.supplierClique = data.data;
                } else {
                    this.$setNotice('分类列表获取失败，刷新试试吧');
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/declare/create.vue